import {
  postRequest,
  handleThrowSubmissionError
} from '../../../../utilities/requests';

export const handleSubmit = async values => {
  const url = '/merchant_applications/bulk_import';
  const payload = new FormData();
  payload.append('file', values.file);
  try {
    await postRequest(url, payload);
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
};
